<template>
</template>

<script>
    import {eventBus} from '../main'

    export default {
        name: "logout",
        components: {
            eventBus
        },
        methods: {
            logout() {
                eventBus.$emit('onStateNavBar', this.$store.getters.isBlocked);
                eventBus.$emit('onHideNavBar', true);
                this.$store.dispatch('logout')
                    .then(() => {
                        this.$router.push('/')
                    })
            }
        },
        created() {
            this.logout();
        }
    }
</script>

<style scoped>

</style>
